import { FILTER_TYPES } from 'components/FilterPod';

const filters = () => [
  {
    title: 'شناسه مجوز',
    label: 'شناسه',
    keyName: 'id',
    query: 'id',
    id: 1,
    // value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
      dir: 'ltr',
    },
  },

];

export default filters;
